import React from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import {setMapBounds,selectMapZoomstate} from "../../../features/maps/mapZoomSlice";
import { useEffect, useState } from "react";
import { MDBDataTableV5 } from "mdbreact";
import Button from "@material-ui/core/Button";
import { closeTools } from "../../../features/tools/toolsSlice";
import { selectLayerDataSet } from "../../../features/layers/overlaylayerslice";
import Data from "./Data";
import { setAnalyticsVisual } from "../../../features/layers/analyticsslice";
import jwt from 'jsonwebtoken';

const ProximityTool = () => {
  const dispatch = useDispatch();
  const state = useSelector(selectMapZoomstate);
  const layers=useSelector(selectLayerDataSet)
  const [source, setSource] = useState([]);
  const epicenter = useSelector(selectMapZoomstate);
  const [data, setData] = useState([]);
  const [browser, setBrowser] = useState(null);
  const [ipAddress, setIPAddress] = useState('');
  const [userdata, setUserData] = useState();
  useEffect(() => {
    const getBrowserDetails = () => {
      const { userAgent, platform } = navigator;
      const browserName = detectBrowser(userAgent);
      const browserVersion = detectBrowserVersion(userAgent);
      const details = {
        userAgent,
        platform,
        browserName,
        browserVersion
      };

      setBrowser(details);
    };

    getBrowserDetails();
  }, []);
  const detectBrowser = (userAgent) => {
    const UAParser = require('ua-parser-js');
    const parser = new UAParser();
    const result = parser.setUA(userAgent).getBrowser();
    return result.name;
  };

  // Function to detect browser version
  const detectBrowserVersion = (userAgent) => {
    const UAParser = require('ua-parser-js');
    const parser = new UAParser();
    const result = parser.setUA(userAgent).getBrowser();
    return result.version;
  };
  useEffect(() => {
    const fetchIPAddress = async () => {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        setIPAddress(data.ip);
      } catch (error) {
        console.error('Error fetching IP address:', error);
      }
    };
    fetchIPAddress();
  }, []);
  
  const userLogs = async () => {
    const formData = new FormData();
    formData.append("browser_used", browser['browserName']+', V '+browser['browserVersion']+ ', OS ' +browser['platform'])
    formData.append("session_time", 0)
    formData.append("ip", ipAddress)
    formData.append("time", Date())
    formData.append("print", 0)
    formData.append("userid", '')
    formData.append("toolused", 'AOI Filter')
    formData.append("q_performed", 'on layer '+epicenter.extra)
    
    try {
      const response = await fetch('http://112.133.197.42/API/user_q.php', {
        method: "POST",
        body: formData,
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log(data);
      } else {
        console.error('Request failed with status:', response.status);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }
  
  let arrdata=[]
  useEffect(() => {
    FetchData()
  }, [epicenter]);
  
  const FetchData = async () => {
    //userLogs()
    const formData = new FormData();
    formData.append("json", JSON.stringify(epicenter.geojson));
    
    try {
      const response = await fetch(epicenter.url, {
        method: "POST",
        body: formData,
      });
      
      if (response.ok) {
        const responseData = await response.json();
        console.log(responseData);
        userLogs();
        dispatch(setAnalyticsVisual({data: responseData, withincol: '', maincol: epicenter.extra}));
      } else {
        console.error('Request failed with status:', response.status);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const ChangeMap = () => {
    dispatch(
      closeTools({
        name: "Proximity",
      })
    );
  };

  return (
    <>
      <Search>
        
      </Search>
    </>
  );
};

export default ProximityTool;

const Search = styled.div`
  .icon {
    padding: 10px;
    background: #38a3a2;
    color: white;
    min-width: 40px !important;
    text-align: center;
    height: 40px;
    cursor: pointer;
    border-radius: 0px;
  }
  .icon-o {
    padding: 10px;
    background: #38a3a2;
    color: white;
    width: 65px !important;
    text-align: center;
    height: 40px;
    cursor: pointer;
    border-radius: 0px;
  }
  input::-webkit-input-placeholder {
    color: #fff;
  }
  .container {
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    top: 90px;
    width: 520px;
    z-index: 10000;
    display: block;
    box-shadow: rgb(17 12 46 / 15%) 0px 48px 100px 0px;
  }
  .input-o {
    width: 78%;
    height: 40px;
    padding: 6px 12px;
    -ms-flex-align: center;
    font-size: 14px;
    border: 1px solid transparent;
    font-family: "Nunito";
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    outline: none;
    background: #fff;
    color: #38a3a2;
  }
  .Button {
    padding: 6px 12px;
    display: block;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    background-color: #014b96;
    color: #fff;
    border-radius: 0px;
    margin-top: 10px;
    font-family: "Nunito";
    text-transform: none;
  }
  .MuiButton-root:hover {
    background-color: #3f4854;
    color: #fff;
  }
  .MuiButton-label {
    font-family: Nunito;
    text-transform: none;
  }
  @media screen and (max-width: 480px) {
    .container {
      position: absolute;
      margin-left: auto;
      margin-right: auto;
      left: 2px;
      right: 0;
      top: 70px;
      width: 95%;
      z-index: 10000;
      display: block;
      box-shadow: rgb(17 12 46 / 15%) 0px 48px 100px;
    }
    .input {
      width: 70%;
    }
    .input-o {
      width: 65%;
    }
    .Button {
      margin-left: auto;
      margin-right: auto;
      display: flex;
    }
    .Locations {
      width: 70% !important;
      margin-left: 15% !important;
      float: left !important;
    }
    .fa-search {
      margin-left: 74%;
    }
  }
  .Locations {
    list-style: none;
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    z-index: 1000;
    background-color: #fff;
    width: 70%;
    float: left;
    height: 2.5rem;
    padding: 6px 12px;
    margin-left: 35%;
    font-size: 14px;
    margin-top: 51px;
  }
  table {
    margin-left: 0%;
    margin-top: 2%;
    margin-bottom: 2%;
    /* max-width: 20%; */
    table-layout: fixed;
    width: 100%;
    /* border: none; */
    border-collapse: collapse;
    border: 1px solid #dadada;
    background-color: #222222;
  }
  table tr {
    margin-bottom: 1px;
    border-bottom: 0.5px solid #dadada;
    word-break: break-all;
    width: 80%;
  }
  table td {
    padding: 6px !important;
    text-align: center !important;
    background-color: white;
    color: black !important;
    font-weight: 400;
  }
  table th {
    padding: 6px !important;
    text-align: center !important;
    background-color: orange !important;
    font-weight: bold !important;
    color: black !important;
    font-weight: "bold";
  }
  p {
    margin-top: 20%;
    font-weight: bold;
    background-color: #004b96bd;
    text-align: center;
    color: white;
    padding: 6px;
  }
`;
